// src/Navbar.js - Liquid Glass Navbar cho Thiếu nhi
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const location = useLocation();
  const lastScrollY = useRef(0);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // 1. Nếu đang ở trên cùng (scrollY <= 20px) -> Luôn hiện nút 3 gạch
      if (currentScrollY <= 20) {
        setIsButtonVisible(true);
      } else {
        // 2. Cuộn xuống -> Ẩn nút 3 gạch
        if (currentScrollY > lastScrollY.current && currentScrollY - lastScrollY.current > 5) {
          setIsButtonVisible(false);
        }
        // 3. Cuộn lên -> Hiện lại nút 3 gạch
        else if (currentScrollY < lastScrollY.current && lastScrollY.current - currentScrollY > 5) {
          setIsButtonVisible(true);
        }
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Tự động đóng menu khi chuyển trang
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const navItems = [
    { path: '/', label: 'Trang chủ', icon: '🏠', color: '#0284c7' },
    { path: '/events', label: 'Sự kiện', icon: '🎉', color: '#ec4899' },
    { path: '/fun-learn', label: 'Vui học cùng Giêsu', icon: '✨', color: '#eab308' },
    { path: '/login', label: 'Giáo lý viên', icon: '✝️', color: '#9333ea' },
  ];

  return (
    <>
      {/* 1. THANH HEADER CHÍNH: Nằm ở đầu trang (cuộn đi theo trang web) */}
      <header className="lgnav-header">
        <div className="lgnav-container">
          {/* Brand / Logo + Tên trường */}
          <Link to="/" className="lgnav-brand" onClick={closeMenu}>
            <div className="lgnav-logo-bubble">
              <img
                src="/logo.png"
                alt="Logo An Nhơn"
                className="lgnav-logo-img"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/logo.png';
                }}
              />
            </div>
            <div className="lgnav-brand-info">
              <span className="lgnav-brand-title">Thiếu Nhi An Nhơn</span>
              <span className="lgnav-brand-sub">Trường Giáo Lý</span>
            </div>
          </Link>

          {/* Desktop Menu (Chỉ hiện trên máy tính) */}
          <ul className="lgnav-desktop-menu">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path} className="lgnav-item">
                  <Link
                    to={item.path}
                    className={`lgnav-link ${isActive ? 'active' : ''}`}
                    style={{ '--lgnav-accent': item.color }}
                  >
                    <span className="lgnav-icon">{item.icon}</span>
                    <span className="lgnav-label">{item.label}</span>
                    {isActive && <span className="lgnav-active-dot"></span>}
                  </Link>
                </li>
              );
            })}
          </ul>

          {/* Vùng đệm chiếm vị trí bên phải trên Mobile để cân đối thanh header */}
          <div className="lgnav-mobile-spacer"></div>
        </div>
      </header>

      {/* 2. NÚT 3 GẠCH TRÊN MOBILE: Chạy theo màn hình (ẩn khi cuộn xuống, hiện khi cuộn lên) */}
      <button
        className={`lgnav-floating-hamburger ${isMenuOpen ? 'open' : ''} ${
          !isButtonVisible && !isMenuOpen ? 'hidden' : ''
        }`}
        onClick={toggleMenu}
        aria-label="Menu"
      >
        <span className="lgnav-line line-1"></span>
        <span className="lgnav-line line-2"></span>
        <span className="lgnav-line line-3"></span>
      </button>

      {/* 3. MODAL POPUP MENU KHI BẤM NÚT 3 GẠCH */}
      <div
        className={`lgnav-mobile-overlay ${isMenuOpen ? 'open' : ''}`}
        onClick={closeMenu}
      >
        <div
          className="lgnav-mobile-card"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="lgnav-mobile-header">
            <span>🌈 Khám phá ngay</span>
            <button className="lgnav-mobile-close" onClick={closeMenu}>
              ✕
            </button>
          </div>
          <ul className="lgnav-mobile-menu">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`lgnav-mobile-link ${isActive ? 'active' : ''}`}
                    onClick={closeMenu}
                  >
                    <span
                      className="lgnav-mobile-icon"
                      style={{
                        backgroundColor: `${item.color}20`,
                        color: item.color,
                      }}
                    >
                      {item.icon}
                    </span>
                    <span className="lgnav-mobile-label">{item.label}</span>
                    {isActive && (
                      <span
                        className="lgnav-mobile-badge"
                        style={{ backgroundColor: item.color }}
                      ></span>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;